import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_data-xm-dev/artifacts/nfhnqfv8_640AB213-1DF7-4C40-9AAA-5ECCBB333955.png";

export const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white relative overflow-hidden" data-testid="footer">
      {/* Background gradient */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-blue-600/5 rounded-full blur-[120px]" />
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-violet-600/5 rounded-full blur-[120px]" />
      </div>
      
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <img src={LOGO_URL} alt="Global Data XM" className="h-16 w-auto" />
            <p className="text-slate-400 text-sm leading-relaxed">
              Building modern digital solutions for businesses ready to scale with web development, AI integration, and marketing technology.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {["Home", "About", "Services", "Contact"].map((link) => (
                <li key={link}>
                  <Link
                    to={link === "Home" ? "/" : `/${link.toLowerCase()}`}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                    data-testid={`footer-link-${link.toLowerCase()}`}
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li className="hover:text-white transition-colors cursor-pointer">Website Development</li>
              <li className="hover:text-white transition-colors cursor-pointer">Custom Workflow Apps</li>
              <li className="hover:text-white transition-colors cursor-pointer">AI Integration</li>
              <li className="hover:text-white transition-colors cursor-pointer">Marketing Technology</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <div className="w-8 h-8 bg-blue-500/10 rounded-lg flex items-center justify-center">
                  <Mail size={14} className="text-blue-400" />
                </div>
                <a href="mailto:globaldataxm@proton.me" className="hover:text-white transition-colors">
                  globaldataxm@proton.me
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <div className="w-8 h-8 bg-violet-500/10 rounded-lg flex items-center justify-center">
                  <Phone size={14} className="text-violet-400" />
                </div>
                <span>Available by request</span>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <div className="w-8 h-8 bg-purple-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin size={14} className="text-purple-400" />
                </div>
                <span>Remote & Global Operations</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Global Data XM. All rights reserved.
          </p>
          <p className="text-sm font-medium tracking-wider bg-gradient-to-r from-blue-400 to-violet-400 bg-clip-text text-transparent">
            WEB • AI • MARKETING
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
